<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-02-17                                                         -
  ----------------------------------------------------------------------------->

<template>
  <b-form-group v-bind="$props">
    <b-form-file v-model="item[field]"
                 :placeholder="placeholder"
                 :accept="accept"
                 :disabled="disabled"
                 :required="required"
                 @change="$emit('change',$event)"
                 @input="$emit('input',$event)">
                 ></b-form-file>
  </b-form-group>

</template>

<script>
import MixinIsFormGroup from "./mixin-is-form-group";

export default {
  name: "yega1-form-group-file-input",
  emits: ['input', 'change'],
  mixins:[
    MixinIsFormGroup
  ],
  props:{
    placeholder:{
      type:String,
      default:'Choose a file...'
    },
    accept:{
      type:String,
      default:'.xlsx'
    }
  }
}
</script>

<style scoped>

</style>
